// @flow

import glamorous from 'glamorous';
import playChip from 'app/images/ui/icon-playchip.svg';
import bonusChip from 'app/images/ui/icon-bonuschip.svg';

const styles = {
  display: 'inline-block',
  height: '1.1em',
  width: '1.1em',
  marginTop: '-0.14em',
  marginRight: '0.15em',
};

export const PlayChip = glamorous('img', {
  withProps: {
    src: playChip,
    alt: 'PlayChip',
  },
})(styles);

export const BonusChip = glamorous('img', {
  withProps: {
    src: bonusChip,
    alt: 'BonusChip',
  },
})(styles);
